<template>
    <view-section-card title="태그입력" class="fill-height">
        <template #actions>
            <v-btn-toggle v-model="mode" mandatory dense group color="primary">
                <v-btn value="text" text small class="text-none my-0">텍스트</v-btn>
                <v-btn value="list" text small class="text-none my-0">리스트</v-btn>
            </v-btn-toggle>
        </template>
        <template v-if="mode == 'list'">
            <tags-list v-model="items" @input="emit" />
        </template>
        <template v-if="mode == 'text'">
            <tags-text v-model="items" @input="emit" />
        </template>
    </view-section-card>
</template>

<script>
import { initCommonMetatag_Tag } from "@/store/metatags";

import ViewSectionCard from "@/components/console/dumb/view/view-section-card.vue";

import TagsList from "./tags/tags-list.vue";
import TagsText from "./tags/tags-text.vue";

export default {
    components: {
        ViewSectionCard,
        TagsList,
        TagsText,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        items: [],
        mode: "text",
    }),
    methods: {
        sync() {
            this.items = [...this.value].map(initCommonMetatag_Tag);
        },
        emit() {
            this.$emit("input", this.items);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
